var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.hideNavDesktop)?_c('AppNavDesktop',{staticClass:"desktop"}):_vm._e(),_c('AppNavMobile',{staticClass:"mobile"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }